<template>
    <main-content>
        <transaction-filter :action="filterAction" :exportExcel="exportToExcel"></transaction-filter>
        <div v-if="status == 'success'">
            <kt-row v-if="$can('read-statistics', 'transaction')">
                <div class="col-lg-3 col-md-3 col-sm-6">
                    <transactionStat
                            :transactionStatistics="statistics.total_profit"
                            :title="$t('label.total_benefit')"
                            :needCurrency="true"
                    />
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                    <transactionStat
                            :transactionStatistics="statistics.transactions_sum"
                            :title="$t('label.total_transactions')"
                            :needCurrency="true"
                    />
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                    <transactionStat
                            :transactionStatistics="statistics.succeeded_trans_count"
                            :title="$t('label.succeeded_transactions_number')"
                            :needCurrency="false"
                    />
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                    <transactionStat
                            :transactionStatistics="statistics.failed_trans_count"
                            :needCurrency="false"
                            :title="$t('label.failed_transactions_number')"
                    />
                </div>
            </kt-row>
            <kt-row v-else>
                <div class="col-lg-4 col-md-4 col-sm-6">
                    <transactionStat
                            :transactionStatistics="statistics.transactions_sum"
                            :title="$t('label.total_transactions')"
                            :needCurrency="true"
                    />
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6">
                    <transactionStat
                            :transactionStatistics="statistics.succeeded_trans_count"
                            :title="$t('label.succeeded_transactions_number')"
                            :needCurrency="false"
                    />
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6">
                    <transactionStat
                            :transactionStatistics="statistics.failed_trans_count"
                            :needCurrency="false"
                            :title="$t('label.failed_transactions_number')"
                    />
                </div>
            </kt-row>
            <kt-datatable v-if="$can('read', 'transaction')" v-bind="datatableProps" ref="datatable">
            </kt-datatable>

            <kt-datatable v-else v-bind="datatablePropsUser" ref="datatable">
            </kt-datatable>
        </div>

    </main-content>
</template>

<script>
import $ from 'jquery'
import { ApiUrl } from '@/common/api.service'
import columns from './datatable/columns'
import commonAccessColumns from './datatable/commonAccessColumns'
import { AuthorizationHeader } from '@/common/jwt.service'
import mainContent from '@/components/main-content'
import transactionFilter from './components/transaction-filter'
import axios from "axios";
import transactionStat from './components/transaction-statistic'
import { transactionService } from '@/common/api.service'
import {mapGetters} from "vuex";

export default {
    components: {
        mainContent,
        transactionFilter,
        transactionStat
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "user_transaction_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('transaction'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                // this.$refs.datatable.reload()

                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        }
                    },
                    // saveState: {
                    //     // save datatable state(pagination, filtering, sorting, etc) in cookie or browser webstorage
                    //     cookie: true,
                    //     webstorage: false,
                    // },
                    pageSize: 15,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },

                pagination: false,
                sortable: true,
                columns: columns,
            }
        },
        datatablePropsUser() {
            return {
                id: "user_transaction_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('transaction'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                // this.$refs.datatable.reload()

                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        }
                    },
                    // saveState: {
                    //     // save datatable state(pagination, filtering, sorting, etc) in cookie or browser webstorage
                    //     cookie: true,
                    //     webstorage: false,
                    // },
                    pageSize: 15,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },

                pagination: false,
                sortable: true,
                columns: commonAccessColumns,
            }
        },
        ...mapGetters('transaction', [
            'statistics','status'
        ])
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
            this.$store.dispatch('transaction/fetchStatistics', query)
        },
        exportToExcel(e, query){
            this.query = query
            axios({
                url: ApiUrl.path('transaction/excel-export'),
                method: 'GET',
                params: this.query,
                responseType: 'blob',
            }).then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'transactions.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            });
            this.$store.dispatch('transaction/fetchStatistics', query)
        }
    },
    mounted() {
        this.$store.dispatch('transaction/fetchStatistics')
    },
}
</script>

<style>
    .kt-datatable__cell {
        font-size: .9rem!important;
    }
    .kt-datatable.kt-datatable--default > .kt-datatable__table > .kt-datatable__body .kt-datatable__row > .kt-datatable__cell,
    .kt-datatable.kt-datatable--default > .kt-datatable__table > .kt-datatable__head .kt-datatable__row > .kt-datatable__cell.kt-datatable__cell--sort {
        padding: 8px!important;
    }
    .kt-datatable.kt-datatable--default > .kt-datatable__table > .kt-datatable__body .kt-datatable__row > .kt-datatable__cell:first-child,
    .kt-datatable.kt-datatable--default > .kt-datatable__table > .kt-datatable__head .kt-datatable__row > .kt-datatable__cell:first-child {
        padding-right: 20px!important;
    }
</style>